<template>
  <div>
    <h2>Municipios</h2>

    <b-row>
      <b-table
        striped
        hover
        show-empty
        ref="provideredTable"
        :busy.sync="tableIsBusy"
        :items="tableProvider"
        :fields="fields"
        :filter="filters"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
        :emptyFilteredText="$t('table.noRecord')"
        :filter-debounce=500
      >
        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th v-for="field in fields" :key="field.key">
              <b-form-input
                v-if="filters[field.key] != null"
                v-model="filters[field.key]"
                :placeholder="'Buscar por ' + field.label"
              />
            </b-th>
          </b-tr>
        </template>
        <template v-slot:cell(prazo)="row">
          <b-form-input v-model="row.item.prazo" v-on:change="onDataChange(row.item)" />
        </template>
        <template v-slot:cell(diasPosColeta)="row">
          <b-form-input v-model="row.item.diasPosColeta" v-on:change="onDataChange(row.item)" />
        </template>
      </b-table>
    </b-row>
    <b-row>
      <b-col sm="5" md="5" lg="5" class="mt-1">
        <b-pagination
          v-model="tableCurrentPage"
          :total-rows="tableRowCount"
          :per-page="tablePerPage"
          first-number
          last-number
          aria-controls="table-tabela-proceda"
        ></b-pagination>
      </b-col>
      <b-col sm="4" md="4" lg="4" class="mt-2">
        <label
          for="perPageSelect"
        >Exibindo {{ paginationFrom }} até {{ paginationTo }} de um total de {{tableRowCount}}</label>
      </b-col>
      <b-col sm="3" md="3" lg="3">
        <b-form-group
          label-cols-md="6"
          label="Por página"
          label-align-md="right"
          label-for="perPageSelect"
        >
          <b-form-select
            class="mt-1"
            v-model="tablePerPage"
            id="perPageSelect"
            size="sm"
            :options="tablePageOptions"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "PrazoEntregaMunicipios",
  props: {
    transportadorId: null,
  },
  computed: {
    paginationFrom() {
      return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.tablePerPage;
      if (to > this.tableRowCount) return this.tableRowCount;
      return to;
    },
  },
  data: function () {
    return {
      fields: [
        {
          label: "Municipio",
          key: "municipio.nome",
          sortable: true,
        },
        {
          label: "Prazo",
          key: "prazo",
          sortable: false,
        },
        {
          label: "Dias pos coleta",
          key: "diasPosColeta",
          sortable: false,
        },
      ],
      filters: {
        "municipio.nome": "",
      },
      items: [],
      tableIsBusy: false,
      tableRowCount: 0,
      tablePerPage: 5,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
      tableLoad: true,
    };
  },
  watch: {
    transportadorId() {
      this.$refs.provideredTable.refresh();
    },
  },
  methods: {
    tableProvider(ctx, callback) {
      this.tableIsBusy = true;
      console.log('provider')

      let apiFilter = {
        shippingCompanyId: this.transportadorId ? this.transportadorId : null,
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        sortBy: ctx.sortBy,
        sortDesc: ctx.sortDesc,
        cityName: ctx.filter["municipio.nome"],
        daysAfterCollection: ctx.filter.diasPosColeta,
        deadline: ctx.filter.prazo,
      };
      this.$api
        .post("/rotaPrazoEntrega/municipios/", apiFilter)
        .then((data) => {
          const items = data.data.items;
          this.tableIsBusy = false;
          this.tableRowCount = data.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.tableIsBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
    onDataChange: function (item) {
      item.prazo = parseInt(item.prazo);
      item.diasPosColeta = parseInt(item.diasPosColeta);

      this.$api
        .post(
          "/rotaPrazoEntrega/save/" +
            item.transportadorId.toString() +
            "/" +
            item.id.toString(),
          item
        )
        .then((response) => {
          item.id = response.data.id;
          console.log(JSON.stringify(item));
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response.data.errors);

          if (error.response.status == 400) {
            alert(error.response.data.errors);
          }
        });
    },
  },
};
</script>

